<template>
  <div class="toggle-container" @click="toggleSwitch">
    <svg v-if="modelValue" xmlns="http://www.w3.org/2000/svg" width="50" height="25" viewBox="0 0 50 25" fill="none">
      <rect x="0.593994" width="49.406" height="24.7742" rx="12.3871" fill="var(--primary-color)" />
      <rect x="27.6875" y="2.32227" width="20.7187" height="20.129" rx="10.0645" fill="white" />
    </svg>
    <svg v-else xmlns="http://www.w3.org/2000/svg" width="49" height="25" viewBox="0 0 49 25" fill="none">
      <rect width="49" height="25" rx="12.5" fill="#D9D9D9" />
      <rect x="2" y="2" width="21" height="21" rx="10.5" fill="white" />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: Boolean, // v-model binding
  },
  methods: {
    toggleSwitch() {
      this.$emit('update:modelValue', !this.modelValue)
    },
  },
}
</script>

<style scoped>
.toggle-container {
  text-align: center;
  cursor: pointer;
  width: 50px;
  height: 25px;
  /* margin-left: 10px; */
}
</style>
